export default __webpack_public_path__ + "static/media/05.23a59e1e.png";